var SIZE_OPTIONS = [
    {
        code: "XS",
        question: "Riesci a portare tutto in una city car?",
        name: "Extra small",
        range: "1 m³",
        detail: "Valigie, scatoloni, cambio armadio.",
        image: "/application/themes/cmc_theme_uno/dist/assets/images/form-size-xs.webp",
    },
    {
        code: "S",
        question: "Riesci a portare tutto in una macchina?",
        name: "Small",
        range: "1-5 mq",
        detail: "Mobili di una stanza, attrezzatura sportiva.",
        image: "/application/themes/cmc_theme_uno/dist/assets/images/form-size-s.webp",
    },
    {
        code: "M",
        question: "Riesci a portare tutto in un pick up?",
        name: "Medium",
        range: "6-10 mq",
        detail: "Arredi di un monolocale o elettrodomestici.",
        image: "/application/themes/cmc_theme_uno/dist/assets/images/form-size-m.webp",
    },
    {
        code: "L",
        question: "Riesci a portare tutto in un grosso furgone?",
        name: "Large",
        range: "11-15 mq",
        detail: "Arredamento completo di un appartamento.",
        image: "/application/themes/cmc_theme_uno/dist/assets/images/form-size-l.webp",
    },
    {
        code: "XL",
        question: "Riesci a portare tutto in un camion?",
        name: "Extra large",
        range: "16-22 mq e oltre",
        detail: "Trasloco di un'intera casa o ufficio grande.",
        image: "/application/themes/cmc_theme_uno/dist/assets/images/form-size-xl.webp",
    },
];

var DATE_OPTIONS = [
    { id: "today", label: "Oggi", shift: "today" },
    { id: "week", label: "Tra una settimana", shift: "days", amount: 7 },
    { id: "two-weeks", label: "Tra due settimane", shift: "days", amount: 14 },
    { id: "month", label: "Tra un mese", shift: "days", amount: 30 },
    { id: "exact", label: "Data esatta", shift: "exact" },
];

function pad(value) {
    return String(value).padStart(2, "0");
}

function toIsoDate(date) {
    return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate());
}

function startOfToday() {
    var date = new Date();
    date.setHours(12, 0, 0, 0);
    return date;
}

function addDays(date, days) {
    var next = new Date(date.getTime());
    next.setDate(next.getDate() + days);
    return next;
}

function dateForOption(option, exactValue) {
    var today = startOfToday();
    if (option.shift === "today") {
        return toIsoDate(today);
    }
    if (option.shift === "days") {
        return toIsoDate(addDays(today, option.amount));
    }
    return exactValue || "";
}

function field(form, name) {
    return form.querySelector('[name="' + name.replace(/"/g, '\\"') + '"]');
}

var TRACKED_CHOICE_FIELDS = [
    "lead[dimensione]",
    "lead[datefrom]",
    "lead[durata]",
    "lead[deposito]",
    "custom[dimensionelabel]",
    "custom[duratalabel]",
    "custom[depositolabel]",
];

function markTrackedChoiceFields(form) {
    TRACKED_CHOICE_FIELDS.forEach(function (name) {
        var control = field(form, name);
        if (control) {
            control.classList.add("form-control");
        }
    });
}

function hideGroup(control) {
    if (!control) {
        return;
    }
    var group = control.closest(".form-group");
    if (group) {
        group.classList.add("form-variant__native");
    }
}

function choice(name, value, title, meta, detail) {
    var label = document.createElement("label");
    label.className = "form-variant__choice";

    var input = document.createElement("input");
    input.type = "radio";
    input.name = name;
    input.value = value;

    var body = document.createElement("span");
    body.className = "form-variant__choice-body";

    var titleEl = document.createElement("span");
    titleEl.className = "form-variant__choice-title";
    titleEl.textContent = title;
    body.appendChild(titleEl);

    if (meta) {
        var metaEl = document.createElement("span");
        metaEl.className = "form-variant__choice-meta";
        metaEl.textContent = meta;
        body.appendChild(metaEl);
    }

    if (detail) {
        var detailEl = document.createElement("span");
        detailEl.className = "form-variant__choice-detail";
        detailEl.textContent = detail;
        body.appendChild(detailEl);
    }

    label.append(input, body);
    return label;
}

function navButton(className, label, arrowAfter) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = className;
    button.textContent = label;
    if (arrowAfter) {
        button.appendChild(document.createTextNode(" →"));
    }
    return button;
}

function stepShell(title, stepIndex, total) {
    var step = document.createElement("section");
    step.className = "form-variant__step";
    step.hidden = stepIndex !== 0;

    var heading = document.createElement("h3");
    heading.className = "form-variant__title";
    heading.tabIndex = -1;
    heading.textContent = title;
    step.appendChild(heading);

    var error = document.createElement("p");
    error.className = "form-variant__error";
    error.hidden = true;
    step.appendChild(error);

    return step;
}

function isIosDevice() {
    return /iP(hone|ad|od)/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
}

function alignVariantForm(form) {
    if (!window.matchMedia("(max-width: 991.98px)").matches) {
        return;
    }
    var viewport = window.visualViewport;
    var viewHeight = viewport ? viewport.height : window.innerHeight;
    var margin = 16;
    var header = document.querySelector("header.site-header");
    var headerBlock = 0;
    if (header) {
        var headerRect = header.getBoundingClientRect();
        if (headerRect.bottom > 0) {
            headerBlock = headerRect.bottom;
        }
    }
    var rect = form.getBoundingClientRect();
    var topLimit = headerBlock + margin;
    var available = viewHeight - margin - topLimit;
    var desiredTop = rect.height <= available
        ? topLimit + (available - rect.height) / 2
        : topLimit;
    var delta = rect.top - desiredTop;
    if (Math.abs(delta) < 4) {
        return;
    }
    window.scrollBy(0, delta);
}

function setError(step, message) {
    var error = step.querySelector(".form-variant__error");
    if (!error) {
        return;
    }
    error.hidden = !message;
    error.textContent = message || "";
}

function initVariantForm(form) {
    if (form.getAttribute("data-form-variant-ready") === "1") {
        return true;
    }

    markTrackedChoiceFields(form);

    if (isIosDevice()) {
        form.classList.add("form-variant--ios");
    }

    var sizeSelect = field(form, "lead[dimensione]");
    var durationSelect = field(form, "lead[durata]");
    var dateInput = field(form, "lead[datefrom]");
    if (!sizeSelect || !durationSelect || !dateInput) {
        return false;
    }

    if (sizeSelect.getAttribute("data-tp-options-loaded") !== "1" || durationSelect.getAttribute("data-tp-options-loaded") !== "1") {
        return false;
    }

    var sizeLabel = field(form, "custom[dimensionelabel]");
    var leadFieldset = sizeSelect.closest("fieldset");
    var contactFieldset = form.querySelector('fieldset[data-step="anagrafica"]');
    var deposito = field(form, "lead[deposito]");
    var note = field(form, "lead[note]");
    hideGroup(sizeSelect);
    hideGroup(durationSelect);
    hideGroup(dateInput);
    hideGroup(deposito);

    var sizes = SIZE_OPTIONS.filter(function (size) {
        return !!sizeSelect.querySelector('option[value="' + size.code + '"]');
    });
    if (!sizes.length) {
        sizes = SIZE_OPTIONS.slice();
    }

    var root = document.createElement("div");
    root.className = "form-variant";

    var progress = document.createElement("div");
    progress.className = "form-variant__progress";
    progress.innerHTML = '<span class="form-variant__kicker">Preventivo gratis</span><span class="form-variant__count"></span><span class="form-variant__bar" aria-hidden="true"><span></span></span>';

    var steps = [];
    var flow = [];
    var branches = [];

    var sizeStep = stepShell("Quanto spazio ti serve?");
    var visual = document.createElement("div");
    visual.className = "form-variant__visual form-variant__visual--empty";
    var visualImg = document.createElement("img");
    visualImg.alt = "";
    visualImg.hidden = true;
    var visualQuestion = document.createElement("p");
    visualQuestion.className = "form-variant__question";
    visualQuestion.textContent = "Tocca una taglia per scoprire cosa riesci a metterci dentro.";
    var visualDetail = document.createElement("p");
    visualDetail.className = "form-variant__detail";
    visualDetail.hidden = true;
    visual.append(visualImg, visualQuestion, visualDetail);
    var sizeList = document.createElement("div");
    sizeList.className = "form-variant__choices form-variant__choices--sizes";
    sizes.forEach(function (size) {
        sizeList.appendChild(choice(
            "form_variant_size",
            size.code,
            size.code,
            size.range
        ));
    });
    sizeStep.append(visual, sizeList);
    if (note) {
        var noteGroup = note.closest(".form-group");
        if (noteGroup) {
            var noteWrap = document.createElement("div");
            noteWrap.className = "form-variant__note";
            noteWrap.appendChild(noteGroup);
            sizeStep.appendChild(noteWrap);
        }
    }
    steps.push(sizeStep);

    var dateStep = stepShell("Quando ti serve?");
    var dateList = document.createElement("div");
    dateList.className = "form-variant__choices";
    DATE_OPTIONS.forEach(function (option) {
        dateList.appendChild(choice("form_variant_date", option.id, option.label));
    });
    var exactWrap = document.createElement("div");
    exactWrap.className = "form-variant__exact";
    exactWrap.hidden = true;
    var exactInput = document.createElement("input");
    exactInput.type = "date";
    exactInput.className = "form-variant__calendar";
    exactInput.min = dateInput.getAttribute("min") || toIsoDate(startOfToday());
    if (dateInput.getAttribute("max")) {
        exactInput.max = dateInput.getAttribute("max");
    }
    exactInput.setAttribute("aria-label", "Data esatta");
    exactWrap.appendChild(exactInput);
    dateStep.append(dateList, exactWrap);
    steps.push(dateStep);

    var durationStep = stepShell("Per quanto tempo?");
    var durationList = document.createElement("div");
    durationList.className = "form-variant__choices form-variant__choices--compact";
    Array.prototype.forEach.call(durationSelect.options, function (option) {
        if (!option.value) {
            return;
        }
        var durationLabel = option.textContent.replace(/\s+/g, " ").trim().toLowerCase();
        durationLabel = durationLabel.charAt(0).toUpperCase() + durationLabel.slice(1);
        durationList.appendChild(choice(
            "form_variant_duration",
            option.value,
            durationLabel
        ));
    });
    durationStep.appendChild(durationList);
    steps.push(durationStep);

    var cityStep = stepShell("In quale città ti serve?");
    cityStep.classList.add("form-variant__step--natural");
    var citySelect = document.createElement("select");
    citySelect.className = "form-control form-variant__select";
    citySelect.name = "form_variant_city";
    citySelect.setAttribute("aria-label", "Città");
    cityStep.appendChild(citySelect);
    steps.push(cityStep);

    var storeStep = stepShell("Quale sede preferisci?");
    var storeList = document.createElement("div");
    storeList.className = "form-variant__choices form-variant__choices--compact";
    storeStep.appendChild(storeList);
    steps.push(storeStep);

    var detailsStep = stepShell("Come possiamo contattarti?");
    var detailsBody = document.createElement("div");
    detailsBody.className = "form-variant__details";
    if (contactFieldset) {
        detailsBody.appendChild(contactFieldset);
    }
    detailsStep.appendChild(detailsBody);
    steps.push(detailsStep);

    function citiesFromBranches(records) {
        var map = {};
        records.forEach(function (record) {
            var area = String(record.area || "").trim();
            var code = String(record.code || "").trim();
            if (!area || !code) {
                return;
            }
            if (!map[area]) {
                map[area] = [];
            }
            map[area].push({
                code: code,
                description: String(record.description || code).trim()
            });
        });
        return Object.keys(map).sort(function (a, b) {
            return a.localeCompare(b, "it");
        }).map(function (area) {
            var stores = map[area].slice().sort(function (a, b) {
                return a.description.localeCompare(b.description, "it");
            });
            return { area: area, stores: stores };
        });
    }

    function renderCities() {
        var selectedValue = citySelect.value;
        citySelect.innerHTML = "";
        var placeholder = document.createElement("option");
        placeholder.value = "";
        placeholder.textContent = "Seleziona una città";
        citySelect.appendChild(placeholder);
        citiesFromBranches(branches).forEach(function (city) {
            var option = document.createElement("option");
            option.value = city.area;
            option.textContent = city.area;
            citySelect.appendChild(option);
        });
        if (selectedValue) {
            citySelect.value = selectedValue;
        }
    }

    function selectedCity() {
        if (!citySelect.value) {
            return null;
        }
        var cities = citiesFromBranches(branches);
        for (var i = 0; i < cities.length; i++) {
            if (cities[i].area === citySelect.value) {
                return cities[i];
            }
        }
        return null;
    }

    function selectedStore() {
        var input = storeList.querySelector("input:checked");
        var city = selectedCity();
        if (!input || !city) {
            return null;
        }
        for (var i = 0; i < city.stores.length; i++) {
            if (city.stores[i].code === input.value) {
                return city.stores[i];
            }
        }
        return null;
    }

    function renderStores(city) {
        storeList.innerHTML = "";
        if (!city) {
            return;
        }
        city.stores.forEach(function (store) {
            storeList.appendChild(choice(
                "form_variant_store",
                store.code,
                store.description
            ));
        });
    }

    function applyDeposito(store) {
        if (!deposito || !store) {
            return false;
        }
        var option = deposito.querySelector('option[value="' + store.code.replace(/"/g, '\\"') + '"]');
        if (!option) {
            option = document.createElement("option");
            option.value = store.code;
            option.textContent = store.description;
            deposito.appendChild(option);
        }
        deposito.value = store.code;
        deposito.dispatchEvent(new Event("change", { bubbles: true }));
        return deposito.value === store.code;
    }

    function rebuildFlow() {
        flow = [cityStep];
        if (storeStep.getAttribute("data-active") === "1") {
            flow.push(storeStep);
        }
        flow.push(dateStep, durationStep, sizeStep, detailsStep);
    }

    function flowIndex(step) {
        return flow.indexOf(step);
    }

    var formTitle = form.querySelector(":scope > h3");
    if (formTitle) {
        formTitle.classList.add("form-variant__form-title");
        root.appendChild(formTitle);
    }
    root.appendChild(progress);

    steps.forEach(function (step) {
        var nav = document.createElement("div");
        nav.className = "form-variant__nav";
        if (step !== cityStep) {
            var back = navButton("form-variant__back", "Torna indietro", false);
            back.addEventListener("click", function () {
                show(flowIndex(step) - 1, true);
            });
            nav.appendChild(back);
        }
        if (step === sizeStep) {
            var next = navButton("form-variant__next", "Continua", true);
            next.addEventListener("click", function () {
                if (validateStep(step)) {
                    show(flowIndex(step) + 1, true);
                }
            });
            nav.appendChild(next);
        }
        if (nav.childElementCount) {
            step.appendChild(nav);
        }
        root.appendChild(step);
    });

    form.insertBefore(root, form.firstChild);

    function selectedSize() {
        var input = sizeList.querySelector("input:checked");
        if (!input) {
            return null;
        }
        return sizes.filter(function (size) { return size.code === input.value; })[0] || null;
    }

    function applySize(size) {
        if (!size) {
            return;
        }
        visual.classList.remove("form-variant__visual--empty");
        visualImg.hidden = false;
        visualImg.src = size.image;
        visualQuestion.textContent = size.question;
        visualDetail.hidden = false;
        visualDetail.textContent = size.detail;
        sizeSelect.value = size.code;
        sizeSelect.dispatchEvent(new Event("change", { bubbles: true }));
        if (sizeLabel) {
            sizeLabel.value = size.name + " (" + size.range + ") — " + size.detail;
        }
    }

    function selectedDateOption() {
        var input = dateList.querySelector("input:checked");
        if (!input) {
            return null;
        }
        return DATE_OPTIONS.filter(function (option) { return option.id === input.value; })[0] || null;
    }

    function applyDate() {
        var option = selectedDateOption();
        exactWrap.hidden = !option || option.shift !== "exact";
        if (!option) {
            dateInput.value = "";
            return "";
        }
        var value = dateForOption(option, exactInput.value);
        dateInput.value = value;
        return value;
    }

    function applyDuration() {
        var input = durationList.querySelector("input:checked");
        if (!input) {
            return false;
        }
        durationSelect.value = input.value;
        durationSelect.dispatchEvent(new Event("change", { bubbles: true }));
        return durationSelect.value === input.value;
    }

    function activateStores(city) {
        renderStores(city);
        storeStep.setAttribute("data-active", "1");
        rebuildFlow();
    }

    function deactivateStores() {
        storeList.innerHTML = "";
        storeStep.removeAttribute("data-active");
        rebuildFlow();
    }

    sizeList.addEventListener("change", function () {
        applySize(selectedSize());
        setError(sizeStep, "");
    });
    dateList.addEventListener("click", function (event) {
        if (!event.target.closest(".form-variant__choice")) {
            return;
        }
        window.setTimeout(function () {
            var option = selectedDateOption();
            applyDate();
            setError(dateStep, "");
            if (!option || (option.shift === "exact" && !exactInput.value)) {
                if (option && option.shift === "exact") {
                    exactInput.focus();
                }
                return;
            }
            if (validateStep(dateStep)) {
                show(flowIndex(dateStep) + 1, true);
            }
        }, 0);
    });
    exactInput.addEventListener("change", function () {
        applyDate();
        setError(dateStep, "");
        if (exactInput.value && validateStep(dateStep)) {
            show(flowIndex(dateStep) + 1, true);
        }
    });
    durationList.addEventListener("click", function (event) {
        if (!event.target.closest(".form-variant__choice")) {
            return;
        }
        window.setTimeout(function () {
            if (validateStep(durationStep)) {
                show(flowIndex(durationStep) + 1, true);
            }
        }, 0);
    });
    citySelect.addEventListener("change", function () {
        var city = selectedCity();
        setError(cityStep, "");
        if (!city) {
            return;
        }
        if (city.stores.length === 1) {
            deactivateStores();
            applyDeposito(city.stores[0]);
            show(flowIndex(cityStep) + 1, true);
            return;
        }
        activateStores(city);
        show(flowIndex(storeStep), true);
    });
    storeList.addEventListener("click", function (event) {
        if (!event.target.closest(".form-variant__choice")) {
            return;
        }
        window.setTimeout(function () {
            var store = selectedStore();
            if (!store) {
                return;
            }
            applyDeposito(store);
            setError(storeStep, "");
            show(flowIndex(storeStep) + 1, true);
        }, 0);
    });

    function validateStep(step) {
        if (step === sizeStep) {
            var size = selectedSize();
            if (!size) {
                setError(step, "Seleziona una taglia per continuare.");
                return false;
            }
            applySize(size);
            setError(step, "");
            return true;
        }
        if (step === dateStep) {
            var option = selectedDateOption();
            if (!option) {
                setError(step, "Seleziona quando ti serve per continuare.");
                return false;
            }
            var value = applyDate();
            if (!value) {
                setError(step, "Scegli la data esatta per continuare.");
                exactInput.focus();
                return false;
            }
            setError(step, "");
            return true;
        }
        if (step === durationStep) {
            if (!applyDuration()) {
                setError(step, "Seleziona per quanto tempo per continuare.");
                return false;
            }
            setError(step, "");
            return true;
        }
        if (step === cityStep) {
            var city = selectedCity();
            if (!branches.length) {
                setError(step, "Attendi il caricamento delle città.");
                return false;
            }
            if (!city) {
                setError(step, "Seleziona una città per continuare.");
                return false;
            }
            if (city.stores.length === 1) {
                applyDeposito(city.stores[0]);
            }
            setError(step, "");
            return true;
        }
        if (step === storeStep) {
            var store = selectedStore();
            if (!store || !applyDeposito(store)) {
                setError(step, "Seleziona una sede per continuare.");
                return false;
            }
            setError(step, "");
            return true;
        }
        return true;
    }

    function show(index, moveFocus) {
        rebuildFlow();
        if (index < 0) {
            index = 0;
        }
        if (index >= flow.length) {
            index = flow.length - 1;
        }
        steps.forEach(function (step) {
            step.hidden = true;
        });
        flow[index].hidden = false;
        var title = flow[index].querySelector(".form-variant__title");
        var count = progress.querySelector(".form-variant__count");
        var bar = progress.querySelector(".form-variant__bar span");
        var isLast = index === flow.length - 1;
        count.textContent = isLast ? "Ultimo step" : "Step " + (index + 1) + " di " + flow.length;
        bar.style.width = Math.round(((index + 1) / flow.length) * 100) + "%";
        if (moveFocus && title) {
            if (isIosDevice()) {
                title.focus({ preventScroll: true });
                window.requestAnimationFrame(function () {
                    alignVariantForm(form);
                });
                window.setTimeout(function () {
                    alignVariantForm(form);
                }, 80);
                window.setTimeout(function () {
                    alignVariantForm(form);
                }, 320);
            } else {
                title.focus();
            }
        }
    }

    form.addEventListener("submit", function (event) {
        rebuildFlow();
        for (var i = 0; i < flow.length; i++) {
            if (flow[i] === detailsStep) {
                continue;
            }
            if (!validateStep(flow[i])) {
                event.preventDefault();
                show(i, true);
                return;
            }
        }
    });

    var preset = sizeList.querySelector('input[value="S"]');
    if (preset) {
        preset.checked = true;
        applySize(selectedSize());
    }

    var lang = String(document.documentElement.lang || "it").split("-")[0].toUpperCase();
    if (!/^[A-Z]{2}$/.test(lang)) {
        lang = "IT";
    }
    fetch("/application/tools/branch_" + lang + "_.json", { credentials: "same-origin", cache: "no-store" })
        .then(function (response) {
            if (!response.ok) {
                throw new Error(response.status);
            }
            return response.json();
        })
        .then(function (data) {
            branches = data && data.records ? data.records : [];
            renderCities();
        })
        .catch(function () {
            setError(cityStep, "Non riesco a caricare le città. Ricarica la pagina.");
        });

    function syncStepMinHeight() {
        root.style.removeProperty("--form-variant-step-min");
        var wasHidden = durationStep.hidden;
        if (wasHidden) {
            durationStep.hidden = false;
            durationStep.classList.add("form-variant__step--measure");
        }
        var height = Math.ceil(durationStep.offsetHeight);
        if (wasHidden) {
            durationStep.classList.remove("form-variant__step--measure");
            durationStep.hidden = true;
        }
        if (height > 0) {
            root.style.setProperty("--form-variant-step-min", height + "px");
        }
    }

    show(0, false);
    syncStepMinHeight();
    window.addEventListener("resize", syncStepMinHeight);
    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(syncStepMinHeight);
    }
    form.setAttribute("data-form-variant-ready", "1");
    return true;
}

function initFormVariant() {
    document.querySelectorAll("form.touchpoint").forEach(markTrackedChoiceFields);

    var forms = document.querySelectorAll("form.touchpoint.touchpoint-form-variant");
    if (!forms.length) {
        return;
    }

    forms.forEach(markTrackedChoiceFields);

    var attempts = 0;
    var timer = window.setInterval(function () {
        var pending = false;
        forms.forEach(function (form) {
            try {
                if (!initVariantForm(form)) {
                    pending = true;
                }
            } catch (error) {
                form.setAttribute("data-form-variant-error", error && error.stack ? error.stack : String(error));
            }
        });
        attempts += 1;
        if (!pending || attempts > 40) {
            window.clearInterval(timer);
        }
    }, 200);
}

export { initFormVariant };
